import React, { useEffect, useState, useRef } from "react";
import { Form, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import FalconCloseButton from "modules/common/FalconCloseButton";
import SoftBadge from "modules/common/SoftBadge";
import { useNotificationStore } from "./store";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import CardDiv from "modules/common/card-div/CardDiv";
import { debounce } from "lodash";
import { formatPhoneNumber } from "modules/utilities/utility";
import { useCallingStore } from './store/store';

const SearchBox = () => {
  const { voitekkCalling, exotelCalling, knowlarityCalling, exotelAmeyoCalling, agamiCalling, ubonaCalling } = useCallingStore();
  const [searchBoxAccess, setSearchBoxAccess] = useState(!(voitekkCalling || exotelCalling || knowlarityCalling || exotelAmeyoCalling || agamiCalling || ubonaCalling));

  useEffect(()=>{
    setSearchBoxAccess((voitekkCalling || exotelCalling || knowlarityCalling));
  },[voitekkCalling, exotelCalling, knowlarityCalling]);
  
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");

  const { searchResult, fetchCaseData } = useNotificationStore();

  const debouncedFetchCaseData = debounce((text) => {
    const searchText = formatPhoneNumber(text);
    fetchCaseData(searchText);
  }, 1000);


  useEffect(() => {
    searchInputValue && debouncedFetchCaseData(searchInputValue);
    return () => debouncedFetchCaseData.cancel();
  }, [searchInputValue]);

  const searchOption = searchResult?.map((item) => {
    return {
      header: (
        <div className="d-flex justify-content-between">
          <>{item.first_name}</>
          <SoftBadge bg="primary">{item.order_display_id}</SoftBadge>
        </div>
      ),

      body: searchInputValue.includes("@") || /^(?:\+?\d{1,3})?\d{10}$/.test(searchInputValue) ? /^(?:\+?\d{1,3})?\d{10}$/.test(searchInputValue) ? (
        <div className="d-flex">
          <span className="flex-1">Phone:</span>
          <span className="col-8">
            <SoftBadge bg="primary">{item?.phone_number}</SoftBadge>
          </span>
        </div>
      ) : (
        <div className="d-flex">
          <span className="flex-1">Email:</span>
          <span className="col-8">
            <SoftBadge bg="primary">{item.email}</SoftBadge>
          </span>
        </div>
      ):null,
      id: item.case_id,
    };
  });

  const dropdownRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setTimeout(() => {
        setDropdownOpen(false);
      }, 500);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <Dropdown show={dropdownOpen} className="search-box">
      <div className="position-relative" ref={dropdownRef} onClick={()=>{searchBoxAccess && alert('Call is not disposed')}}>
        <Form.Control
          disabled={searchBoxAccess}
          type="search"
          placeholder={searchBoxAccess ? 'Search disabled as call not disposed': "Email Contact or Order Id"}
          aria-label="Search"
          className="rounded-pill search-input"
          value={searchInputValue}
          onChange={({ target }) => setSearchInputValue(target.value)}
          onFocus={() => setDropdownOpen(true)}
          // onBlur={() => setDropdownOpen(false)}
        />
        <FontAwesomeIcon
          icon="search"
          className="position-absolute text-400 search-box-icon"
        />
        {(dropdownOpen || searchInputValue) && (
          <div className="search-box-close-btn-container">
            <FalconCloseButton
              size="sm"
              noOutline
              className="fs--2"
              onClick={() => {
                setSearchInputValue("");
                setDropdownOpen(false);
              }}
            />
          </div>
        )}
      </div>
      <DropdownMenu>
        <div className="d-flex gap-2 flex-column">
          {searchOption.map((item) => (
            <Link to={`/lead-details/${item?.id}`} key={item?.id}>
              <div>
                <CardDiv
                  title={item.header}
                  component={
                    <span className="fw-bold text-black">{item.body}</span>
                  }
                />
              </div>
            </Link>
          ))}
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default SearchBox;
